import styled from 'styled-components';
import { BP_MOBILE_MAX, BP_NOTEBOOK_MAX } from '../../assets/styles/breakpoints';

export default styled.div`
  min-height: 100px;
  height: auto;
  width: 100%;

  /* overflow: hidden; */
  border-bottom-left-radius: 100px;
  border-bottom-right-radius: 100px;
  box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.3);
  background-image: linear-gradient(to bottom, #3a3851, #2f2e41 84%, #1c1c2b);
  transition: all 1s ease;
  margin-top: -1px;
  ${({ isExtended }) => (isExtended ? 'padding: 32px 0 0 0;' : 'padding: 32px 0;')}

  @media (max-width: ${BP_NOTEBOOK_MAX}px) {
    border-bottom-left-radius: 48px;
    border-bottom-right-radius: 48px;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    border-bottom-left-radius: 24px;
    border-bottom-right-radius: 24px;
    ${({ isExtended }) => (isExtended ? 'padding: 16px 0 0 0;' : 'padding: 16px 0;')}
    min-height: auto;
  }
`;
